export const favoritesKeys = {
	all: ['mantang', 'profile', 'favorites'] as const,
	detail: (stationId: string) => [...favoritesKeys.all, stationId] as const,
};
